import React, {useEffect} from 'react';
import {WebflowSiteModules} from '@packages/systems/core/helpers/SiteIframeMigrationHelper';

export const useWebflowSiteModules = (element: HTMLElement | null) => {
  const [webflowModules, setWebflowModules] = React.useState<
    WebflowSiteModules | undefined
  >(element?.ownerDocument?.defaultView?.Webflow);

  useEffect(() => {
    if (!element) return;
    const win = element.ownerDocument?.defaultView;
    if (!win) return;

    // Initial check
    if (win.Webflow) {
      setWebflowModules(win.Webflow);
      return;
    }

    // Create observer to watch for changes to window object
    const observer = new MutationObserver(() => {
      if (win.Webflow) {
        setWebflowModules(win.Webflow);
        observer.disconnect();
      }
    });

    // Observe changes to document head where webflow.js is injected
    observer.observe(win.document.head, {
      childList: true,
    });

    return () => observer.disconnect();
  }, [element]);

  return webflowModules;
};
